/** @returns {number|undefined} HTTP status carried by an API or fetch error */
export function getErrorStatus(error) {
  return error?.status ?? error?.statusCode
}

// The backend answers 404 for both "does not exist" and "not in your scope",
// so callers must present the two identically.
export const isNotFoundError = (error) => getErrorStatus(error) === 404
export const isAccessDeniedError = (error) => getErrorStatus(error) === 403

/**
 * Retry configuration based on error type
 * @param {number} failureCount - Current failure count
 * @param {Error} error - Error object
 * @returns {boolean} Whether to retry
 */
export function shouldRetryError(failureCount, error) {
  const maxRetries = 2

  if (failureCount >= maxRetries) return false

  const status = getErrorStatus(error)

  // Don't retry client errors (4xx) except timeouts and rate limits.
  // 401 is handled by the fetch layer (refresh, then sign out); 403 is final.
  if (status >= 400 && status < 500) {
    return status === 408 || status === 429
  }

  // Retry server errors (5xx) and network errors
  return status >= 500 || !status
}
